import { useEffect, useState } from "react";

interface LoadVideoParams {
  otp: string;
  playbackInfo: string;
  container: HTMLElement;
  configuration?: Record<string, string>;
}

interface VdoCipherAPI {
  loadVideo: (params: LoadVideoParams) => HTMLIFrameElement;
  isAPIReady: boolean;
}

export default function useVdoCipher(): VdoCipherAPI {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);

  useEffect(() => {
    if (isScriptLoaded) return;

    const existingScript = document.querySelector(
      `script[src="https://player.vdocipher.com/v2/api.js"]`
    );
    if (existingScript) {
      setIsScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://player.vdocipher.com/v2/api.js";
    script.async = true;
    script.onload = () => setIsScriptLoaded(true);
    document.body.appendChild(script);
  }, [isScriptLoaded]);

  const loadVideo = ({
    otp,
    playbackInfo,
    container,
    configuration = {},
  }: LoadVideoParams): HTMLIFrameElement => {
    const params = new URLSearchParams({
      otp,
      playbackInfo,
      ...configuration,
    });

    const iframe = document.createElement("iframe");
    iframe.setAttribute("allowfullscreen", "true");
    iframe.setAttribute("allow", "autoplay; encrypted-media");
    iframe.setAttribute("frameborder", "0");
    iframe.style.height = "100%";
    iframe.style.width = "100%";
    iframe.style.overflow = "auto";
    iframe.src = `https://player.vdocipher.com/v2/?${params.toString()}`;

    container.appendChild(iframe);
    return iframe;
  };

  return {
    loadVideo,
    isAPIReady: isScriptLoaded,
  };
}
